// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*RESPONSIVE VARIABLES*/
/*defined in breakpoints.scss*/
/* CONTAINER*/
/* BORDER*/
/* BOX SHADOW*/
/* FONT*/
/* BODY*/
/* SPACING*/
/* FORM*/
/* Footer Header*/
.kinder-gardens {
  height: 100%;
  width: 100%;
  position: relative;
  top: auto;
  display: flex;
  flex-direction: column;
}
.kinder-gardens .mapDiv {
  width: 100%;
}
@media (max-width: 767.98px) {
  .kinder-gardens .mapDiv {
    height: 60%;
  }
}
@media (min-width: 620px) {
  .kinder-gardens .mapDiv {
    height: 80vh;
  }
}
.kinder-gardens .content {
  overflow: scroll;
  box-shadow: 0 3.2px 7.2px 0 rgba(0, 0, 0, 0.1);
}
@media (max-width: 767.98px) {
  .kinder-gardens .content {
    height: 40vh;
    position: relative;
    left: 0;
    width: 100%;
  }
}
@media (min-width: 620px) {
  .kinder-gardens .content {
    height: 100%;
    z-index: 900;
    position: absolute;
    top: calc(30px / 2);
    right: calc(30px / 2);
    padding-top: 0px;
    width: 30%;
  }
}
.kinder-gardens .list {
  display: flex;
  flex-direction: column;
}
.kinder-gardens .list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  overflow: scroll;
  background: #ffffff;
  opacity: 0.9;
}
.kinder-gardens .list-header {
  background: rgba(255, 255, 255, 0.5);
  padding: 5px 30px;
  font-size: 14px;
  max-width: 60%;
}
.kinder-gardens .list-item {
  padding: calc(30px / 2) 30px;
  background-color: #ffffff;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  max-width: 100%;
}
.kinder-gardens .list-item:not(:last-child) {
  border-bottom: 1px solid #dddddd;
}
.kinder-gardens .list-item:hover {
  background-color: #f8f9fa;
}
.kinder-gardens .list-item h3 {
  margin: 0;
  margin-bottom: 5px;
}
.kinder-gardens .list-item p {
  color: black;
  margin: 0;
}
.kinder-gardens .detail {
  width: 0%;
  font-size: 0;
  overflow-y: scroll;
  z-index: 3;
  overflow-x: hidden;
  background: #ffffff;
  padding: 0px;
  margin: 0px auto 0px auto;
}
@media (min-width: 620px) {
  .kinder-gardens .detail {
    top: 0;
    height: 100%;
    position: absolute;
  }
}
@media (max-width: 767.98px) {
  .kinder-gardens .detail {
    position: absolute;
    top: 0;
    height: 100%;
  }
}
.kinder-gardens .detail p {
  line-height: 2;
}
.kinder-gardens .detail.show {
  width: 100%;
  font-size: inherit;
  padding: 30px;
  transition: width 200ms ease-out, font-size 200ms ease-out, padding 200ms ease-out;
}
.kinder-gardens .detail-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}
.kinder-gardens .detail-back:hover {
  opacity: 1;
}
.kinder-gardens .detail-back:hover span {
  margin-left: 30px;
}
.kinder-gardens .detail-back span {
  margin-left: calc(30px / 2);
  transition: margin-left 0.2s ease-in-out;
}
.kinder-gardens .detail .shortDesc {
  line-height: 130%;
}

main {
  text-align: center;
}
main mat-spinner {
  position: absolute;
  width: 100px;
  height: 100px;
  margin-top: 30px;
  left: calc(50% - 50px);
}

:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/app/components/list/list.component.scss","webpack://./src/styles/breakpoints.scss","webpack://./src/styles/definitions/colors.scss"],"names":[],"mappings":"AAEA,uBAAA;AACA,8BAAA;AAEA,aAAA;AAIA,UAAA;AAKA,cAAA;AAOA,QAAA;AAOA,QAAA;AAKA,WAAA;AAIA,QAAA;AAIA,iBAAA;ACpCA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EAEA,SAAA;EACA,aAAA;EACA,sBAAA;AAKF;AAHE;EAEE,WAAA;AAIJ;ACmBI;EDzBF;IAII,WAAA;EAMJ;AACF;ACGI;EDdF;IAQI,YAAA;EAOJ;AACF;AAJE;EACE,gBAAA;EAmBA,8CD5BS;ACgBb;ACKI;EDbF;IAGI,YAAA;IACA,kBAAA;IACA,OAAA;IACA,WAAA;EASJ;AACF;ACdI;EDFF;IASI,YAAA;IACA,YAAA;IAEA,kBAAA;IACA,mBAAA;IACA,qBAAA;IACA,gBAAA;IACA,UAAA;EAUJ;AACF;AAJE;EACE,aAAA;EACA,sBAAA;AAMJ;AAJI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,OAAA;EACA,gBAAA;EACA,mBEvCE;EFwCF,YAAA;AAKN;AAFI;EACE,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAIN;AADI;EACE,4BAAA;EACA,yBEpDE;EFqDF,6CAAA;EACA,eAAA;EACA,eAAA;AAGN;AADM;EACE,gCAAA;AAGR;AAAM;EACE,yBE1EG;AF4EX;AACM;EACE,SAAA;EACA,kBAAA;AACR;AAEM;EACE,YD9DgB;EC+DhB,SAAA;AAAR;AAKE;EAEE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBEpFI;EFqFJ,YAAA;EACA,yBAAA;AAJJ;AC3EI;EDsEF;IAYI,MAAA;IACA,YAAA;IACA,kBAAA;EAHJ;AACF;ACvEI;ED2DF;IAkBI,kBAAA;IACA,MAAA;IACA,YAAA;EAFJ;AACF;AAII;EACE,cAAA;AAFN;AAKI;EAEI,WAAA;EACA,kBAAA;EACA,aD/FI;ECgGJ,kFAAA;AAJR;AAQI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;AANN;AAQM;EACE,UAAA;AANR;AAQQ;EACE,iBD/GE;ACyGZ;AAUM;EACE,2BAAA;EACA,wCAAA;AARR;AAWI;EACE,iBAAA;AATN;;AAcA;EACE,kBAAA;AAXF;AAYE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAVJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAXF","sourcesContent":["@import \"definitions/colors\";\n\n/*RESPONSIVE VARIABLES*/\n/*defined in breakpoints.scss*/\n\n/* CONTAINER*/\n$container-max-width: 3200px;\n$container-secondary-max-width: 960px;\n\n/* BORDER*/\n$border-color: $brand-grey-dark;\n$border-radius: 6px;\n$border-radius--wide: 40px;\n\n/* BOX SHADOW*/\n$box-shadow-color: rgba($black, .1);\n$box-shadow-size: 3.2px 7.2px;\n$box-shadow--wide-size: 40px;\n$box-shadow: 0 3.2px 7.2px 0 $box-shadow-color;\n$box-shadow--wide: 0 0 $box-shadow--wide-size 0 $box-shadow-color;\n\n/* FONT*/\n$font-family: 'Montserrat', sans-serif;\n$font-family-secondary: 'Amatic SC', cursive;\n$font-size: 16px;\n$font-size-secondary: 26px;\n$font-weight: 300;\n\n/* BODY*/\n$body-color: $black;\n$body-color--secondary: black;\n$body-bg: $brand-pale;\n\n/* SPACING*/\n$padding-x: 30px;\n$padding-y: 30px;\n\n/* FORM*/\n$input-border-radius: calc(#{$border-radius--wide} / 3);\n$button-height: 50px;\n\n/* Footer Header*/\n$footerHeight:50px;\n$headerHeight:70px;\n\n\n\n","@import \"../../../styles/variables\";\n@import \"../../../styles/breakpoints\";\n\n$detailTransitionTime : 200ms;\n\n.kinder-gardens {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  // background-color:blue;\n  top:auto;\n  display: flex;\n  flex-direction: column;\n\n  .mapDiv{\n\n    width: 100%;\n    @include media-breakpoint-down(sm) {\n      height: 60%;\n    }\n\n    @include media-breakpoint-up(sm) {\n      height: 80vh;\n    }\n  }\n\n  .content { // list of KGs and detail\n    overflow: scroll;\n    @include media-breakpoint-down(sm) {\n      height: 40vh;\n      position: relative; // under the map\n      left:0;\n      width: 100%;\n    }\n    @include media-breakpoint-up(sm) {\n      height: 100%;\n      z-index: 900; // to kill leaflet map\n\n      position: absolute; // inside of the map\n      top: calc(#{$padding-y} / 2);\n      right: calc(#{$padding-y} / 2);\n      padding-top:0px;\n      width:calc(30%);\n\n    }\n\n    box-shadow: $box-shadow;\n  }\n\n  .list {\n    display: flex;\n    flex-direction: column;\n  \n    ul {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n\n      flex: 1;\n      overflow: scroll;\n      background: $white;\n      opacity: 0.9;\n    }\n\n    &-header {\n      background: rgba($white, 0.5);\n      padding: 5px $padding-x;\n      font-size: 14px;\n      max-width: 60%;\n    }\n\n    &-item {\n      padding: calc(#{$padding-y} / 2) $padding-x;\n      background-color: $white;\n      transition: background-color 0.2s ease-in-out;\n      cursor: pointer;\n      max-width: 100%;\n\n      &:not(:last-child) {\n        border-bottom: 1px solid $border-color;\n      }\n\n      &:hover {\n        background-color: $gray-100;\n      }\n\n      h3 {\n        margin: 0;\n        margin-bottom: 5px;\n      }\n\n      p {\n        color: $body-color--secondary;\n        margin: 0;\n      }\n    }\n  }\n\n  .detail {\n\n    width: 0%;\n    font-size: 0;\n    overflow-y: scroll;\n    z-index: 3;\n    overflow-x: hidden;\n    background: $white;\n    padding: 0px;\n    margin: 0px auto 0px auto ;\n\n    @include media-breakpoint-up(sm) {\n      top: 0;\n      height: 100%;\n      position: absolute; // not working if it is not in both include media\n\n    }\n    @include media-breakpoint-down(sm) {\n      position: absolute;\n      top: 0;\n      height: 100%;\n    }\n\n    p{\n      line-height: 2;\n    }\n\n    &.show {\n      // @include media-breakpoint-down(sm) {\n        width: 100%;\n        font-size: inherit;\n        padding: $padding-x;\n        transition: width $detailTransitionTime ease-out, font-size  $detailTransitionTime ease-out, padding $detailTransitionTime ease-out;\n      // }\n    }\n\n    &-back {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      opacity: 0.5;\n      transition: opacity 0.2s ease-in-out;\n\n      &:hover {\n        opacity: 1;\n\n        span {\n          margin-left: $padding-x;\n        }\n      }\n\n      span {\n        margin-left: calc(#{$padding-x} / 2);\n        transition: margin-left 0.2s ease-in-out;\n      }\n    }\n    .shortDesc{\n      line-height: 130%;\n    }\n  }\n}\n\nmain {\n  text-align: center;\n  mat-spinner{\n    position:absolute;\n    width:100px;\n    height: 100px;\n    margin-top: 30px;\n    left:calc(50% - 50px);\n  }\n}\n\n:host {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n","// DELETE THIS CLASS\n\n$grid-breakpoints: (\n        xs: 0,\n        sm: 620px,\n        md: 768px,\n        lg: 992px,\n        xl: 1600px\n);\n\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// === BRAND COLORS === //\n$brand-red: #e2001a;\n$brand-grey-dark: #dddddd;\n$brand-grey-darker: #666666;\n\n$brand-pale: #fff1e6;\n$brand-green: #a5a58d;\n\n// === GRAYS === //\n$gray-100: #f8f9fa;\n$gray-200: #e9ecef;\n$gray-300: #dee2e6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #6c757d;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n\n// === APP COLORS === //\n$black: #000000;\n$white: #ffffff;\n$light: #f9f9f9;\n$dark: $brand-grey-darker;\n$primary: $black;\n$accent: #0050A8;\n$success: #28a745;\n$danger: rgba(255, 0, 0, 0.38);\n\n\n// === ANTIBODIES & ANTIGENS CODES === //\n// basic code\n$code-bg--basic: $gray-200;\n$code-border-color--basic: $gray-600;\n$code-color--basic: $gray-600;\n\n// matching code\n$code-bg--matching: rgba($success, 0.2);\n$code-border-color--matching: $success;\n$code-color--matching: $success;\n\n// bad matching code\n$code-bg--bad-matching: rgba($danger, 0.2);\n$code-border-color--bad-matching: $danger;\n$code-color--bad-matching: $danger;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
